import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrCardOld from 'client/components/SrCardOld';
import SrEmoji from 'client/components/SrEmoji';

const SR_FEATURE_CARD_TYPE_TO_CLASSNAME_MAPPING = {
  row: 'type-row',
  box: 'type-box',
};

const subTitleStyleBox = {
  font: 'whitney-sc',
  color: 'grey',
  weight: 'medium',
  letterSpacing: '0.35px',
  fontSize: '21px',
};

const subTitleStyleRow = {
  font: 'whitney-sc',
  color: 'grey',
  weight: 'medium',
  letterSpacing: '0.5px',
  fontSize: '16px',
};

const SrFeatureCard = ({
  type,
  title,
  subtitle,
  emoji,
  ctaLabel,
  ctaOnClick,
  iconClassName,
  className,
}) => {
  const componentClassNames = classnames(
    'SrFeatureCard',
    SR_FEATURE_CARD_TYPE_TO_CLASSNAME_MAPPING[type],
    ctaLabel && ctaOnClick && 'hasCta',
    subtitle && subtitle.split('\n').length >= 2 && 'hasMultiline',
    className,
  );
  const ctaDOM = ctaLabel && ctaOnClick && (
    <SrText
      align="center"
      display="block"
      color="blue300"
      font="whitney-sc"
      weight="medium"
      size="larger"
      cursor="pointer"
      onClick={ctaOnClick}
      className="cta"
    >
      {ctaLabel}
    </SrText>
  );
  if (type === 'row') {
    return (
      <SrCardOld className={componentClassNames} onClick={ctaOnClick}>
        <SrFlex direction="col" justify="between" height="100%">
          <SrText size="2xl" weight="bold">
            {title}
          </SrText>
          <SrText {...subTitleStyleRow}>{`${subtitle}`.toLowerCase()}</SrText>
        </SrFlex>
        {emoji && (
          <SrBox marginTop={1}>
            <SrEmoji emoji={emoji} className="emoji" />
          </SrBox>
        )}
        {ctaLabel && ctaOnClick && <SrText>{ctaLabel}</SrText>}
        {ctaDOM}
      </SrCardOld>
    );
  }

  return (
    <SrCardOld className={componentClassNames}>
      <SrFlex direction="col" justify="between" align="center" height="100%">
        {title && (
          <SrText className="SrFeatureCardTitle" weight="bold">
            {title}
          </SrText>
        )}
        {emoji && (
          <SrBox>
            <SrEmoji emoji={emoji} className="emoji" />
          </SrBox>
        )}
        {iconClassName && (
          <SrFlex className="icon">
            <SrBox className={iconClassName} />
          </SrFlex>
        )}
        <SrText {...subTitleStyleBox} className="SrFeatureCardSubTitle">
          {`${subtitle}`.toLowerCase()}
          {ctaDOM}
        </SrText>
      </SrFlex>
    </SrCardOld>
  );
};

SrFeatureCard.propTypes = {
  type: PropTypes.oneOf(Object.keys(SR_FEATURE_CARD_TYPE_TO_CLASSNAME_MAPPING)),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  emoji: PropTypes.string,
  iconClassName: PropTypes.string,
  className: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaOnClick: PropTypes.func,
};

SrFeatureCard.defaultProps = {
  type: 'box',
};

SrFeatureCard.displayName = 'SrFeatureCard';

export default SrFeatureCard;
